export const offer = {
  creationStateLabel: "Status für neue Angebote",
  creationStateHelp:
    "Beim Erstellen von neuen Angeboten muss ein Status angegeben werden. Dieser kann hier ausgewählt werden.",
  info: "Wenn nur Bestand oder Preis aktiviert ist, dann muss mindestens ein Angebot zu dem Artikel angelegt sein, damit der Bestand oder Preis aktualisiert wird.",
  productAssignment: "Artikelzuordnung",
  productAssignmentHelp:
    "Damit die Artikelzuordnung korrekt funktioniert, müssen die Felder richtig gemapped werden (productNumber auf Markplatz Artikelnummer, ean auf GTIN)."
};
